import React, { useState, useEffect } from 'react'
import { Container, Row, Col, Spinner } from 'react-bootstrap'
import pdf from '../../media/PriceList.pdf'

export default function PriceList() {

    const [loading, setLoading] = useState(true)

    useEffect(() => {
        setTimeout(() => setLoading(false), 300)
    }, [])

    return (
        <>
            {loading === false ? (
                <Container fluid>
                    <div className='greyHeader'>
                        <h1>Märzen - US Commercial Price List</h1>
                    </div>
                    <Container>
                        <Row className='paddingTop'>
                            <Col>
                                <iframe className='pdf' title='PriceListPDF' src={`${pdf}#view=fitH`} />
                            </Col>
                        </Row>
                    </Container>
                </Container>
            ) : (
                <Spinner animation='border' role='status' className='spinner'>
                    <span className='invisible'>Loading...</span>
                </Spinner>
            )}
        </>
    )
}